<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     联系我们
  +---------------------------------------------------------------------------------------
-->
<template>
  <el-dialog custom-class="f-contact-us" :visible.sync="dialogVisible" width="320px" top="25vh">
    <img src="@/assets/work-weixin-contact-me.jpg" width="320">
  </el-dialog>
</template>

<script>
export default {
  name: "FContactUs",

  data() {
    return {
      dialogVisible: false
    }
  },

  mounted() {
  },

  methods: {
    handleClose() {
      this.$destroy(true)
      this.$el.parentNode.removeChild(this.$el)
    },
  }
}
</script>

<style lang="scss">
.f-contact-us {
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
  }
}
</style>
